const theme = {
	images: {
		logo: "https://cdn4.fincaraiz.com.co/web/6765a155e1799_encuentra24.png",
		isotipo: "https://cdn4.fincaraiz.com.co/web/6765a176a019f_favicon_encuentra.png",
		favicon: "https://cdn4.fincaraiz.com.co/web/6765a11e307a5_favicon_encuentra.ico",
		icono: "https://cdn4.fincaraiz.com.co/web/6765a176a019f_favicon_encuentra.png",
	},
	fontFamily: "DM Sans, Muli, sans-serif",
	colors: {
		primaryColor: "#EB0A6C",
		primaryDarkColor: "#EB0A6C",
		primaryHoverColor: "#980250",
		primaryLightColor: "#FF7AC5",
		secondaryColor: "#2D81BE",
		primaryColorV2: '#000000',
		secondaryDarkColor: "#980250",
		secondaryHoverColor: "rgba(235, 10, 108, 0.5)",
		secondaryOpacityColor: "rgba(235, 10, 108, 0.5)",
		textColorHigh: "#000000",
		textColorMedium: "#484848",
		textColorLow: "#8A8A8A",
		textSecondaryColor: "#808080",
		textOnSecondaryColor: "#fff",
		textInverseColor: "#a7a7a7",
		textHoverColor: "#980250",
		textLinkSecondary: "#EB0A6C",
		backgroundColor: "#fff",
		backgroundMainColor: "#EB0A6C",
		backgroundModalColor: "rgba(0, 0, 0, 0.5)",
		backgroundMenuColor: "#FFFFFF",
		textMenuColor: "#8A8A8A",
		linkColor: "#EB0A6C",
		linkHoverColor: "#980250",
		backgroundColorAternative: "#FFF3F8",
		borderColor: "#E9E9E9",
		favoriteColor: "#ff6767",
		successColor: "#69AD6C",
		errorColor: "#F24E1E",
		warningColor: "#fff3cd",
		placeholderTextColor: "#cccccc",
		contentButtonColor: "#EB0A6C",
		backgroundHighColor: "#EB0A6C",
		backgroundMediumColor: "#FF1E6A",
	},
	breakPoints: {
		xs: "576px",
		sm: "576px",
		md: "768px",
		lg: "992px",
		xl: "1200px",
		xxl: "1600px",
	},
	headerHeight: 64,
	spacing: {
		xsSpacing: 4,
		smSpacing: 8,
		mdSpacing: 12,
		lgSpacing: 16,
		xlSpacing: 24,
		xxlSpacing: 32,
	},
	fontSizes: {
		baseFontSize: "16px",
		baseLineHeight: 1.5,

		lgFontSize: "16px",
		smFontSize: "13px",
		xsFontSize: "11px",

		xlTitle: "32px",
		xlLineHeight: "40px",
		lgTitle: "28px",
		lgLineHeight: "36px",
		mdTitle: "24px",
		mdLineHeight: "32px",
		smTitle: "20px",
		smLineHeight: "28px",
		xsTitle: "18px",
		xsLineHeight: "24px",
	},
};

module.exports = theme;